import { LinkButton, SparkLendIcon } from '@/components';
import { useChartFillDatasetsDates } from '@/hooks';
import { CurrencyValue, Flex, KpiCard, LineChart } from '@blockanalitica/ui';
import { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
import AsyncHomeCard from './AsyncHomeCard';

export default function SparkLendCard({
  data,
  error,
  isLoading
}: {
  data: Record<string, any> | undefined;
  error: Error | undefined;
  isLoading: boolean;
}) {
  const theme = useTheme();
  const datasets = useMemo(
    () => [
      {
        xField: 'date',
        yField: 'tvl',
        borderColor: theme.colors.spark.sparkLendPrimary
      }
    ],
    [theme.colors.spark.sparkLendPrimary]
  );

  const customConfig = useMemo(
    () => ({
      options: {
        aspectRatio: 2.5,
        animation: false,
        onResize: () => null,
        scales: {
          x: {
            display: false
          },
          y: {
            display: false
          }
        },
        plugins: {
          tooltip: {
            enabled: false
          }
        }
      },
      plugins: [
        {
          afterDraw: null
        }
      ]
    }),
    []
  );

  const chartData = useChartFillDatasetsDates(
    data?.sparklend_historic,
    datasets,
    90
  );
  const valueFormatter = useCallback((value: string | number) => {
    return <CurrencyValue value={value} variant="dynamic" />;
  }, []);

  return (
    <AsyncHomeCard
      error={error || !data}
      isLoading={isLoading}
      title={
        <>
          <SparkLendIcon size="1" /> SparkLend
        </>
      }>
      <Flex>
        <KpiCard
          title="Total Value Locked"
          field="tvl"
          variant="homeKpiCard"
          // @ts-ignore
          data={data}
          options={{
            currency: 'USD',
            notation: 'compact',
            variants: {
              kpiHeader: 'homeKpiCard',
              valueCurrencyValue: 'normal',
              kpiCardValue: 'mainValue'
            }
          }}
        />
      </Flex>

      <LineChart
        data={chartData}
        datasets={datasets}
        // @ts-ignore
        config={customConfig}
        valueFormatter={valueFormatter}
        showValuesInTooltip={true}
        // @ts-ignore
        variant="homeChart"
      />

      <Flex flexDirection="column" gap="2xs" fontSize="-1">
        <Flex justifyContent="space-between">
          <Flex color="muted">Total Deposits</Flex>
          <CurrencyValue value={data?.sparklend_total_deposits} />
        </Flex>
        <Flex justifyContent="space-between">
          <Flex color="muted">Revenue</Flex>
          <CurrencyValue value={data?.sparklend_revenue} />
        </Flex>
      </Flex>

      <LinkButton to="/sparklend" variant="whiteAndUgly">
        Explore
      </LinkButton>
    </AsyncHomeCard>
  );
}
